var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.694,
    height: 29.476,
    viewBox: "0 0 47.694 29.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mastercard_2019_logo",
    transform: "translate(-2898.736 -2239.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7098",
    "data-name": "Path 7098",
    d: "M3263.546,2305.6h12.9v23.172h-12.9Z",
    transform: "translate(-347.411 -62.943)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7099",
    "data-name": "Path 7099",
    d: "M2916.954,2254.241a14.776,14.776,0,0,1,5.609-11.586,14.738,14.738,0,1,0,0,23.172A14.714,14.714,0,0,1,2916.954,2254.241Z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7100",
    "data-name": "Path 7100",
    d: "M3423,2254.241a14.722,14.722,0,0,1-23.826,11.586,14.772,14.772,0,0,0,0-23.172A14.722,14.722,0,0,1,3423,2254.241Z",
    transform: "translate(-476.566)",
    fill: "#f79e1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.b88c1551b86979903ccbbd4d08c08cf6.svg";
export { ForwardRef as ReactComponent };